import type { BackofficeOrganizationFeatures, BackofficeTierTemplate } from '../types';

export const DEFAULT_FEATURES: BackofficeOrganizationFeatures = {
  organizations: true,
  domains: false,
  sso: false,
  integrations: false,
  apikeys: false,
  bringYourOwnParticipants: false,
  customParticipantPrivacy: false,
  interviewRecordingPrivacy: false,
  collectParticipantEmail: false,
  workspaces: false,
  customerListening: false,
  customerListeningSms: false,
  outboundPhoneCalls: false,
  insights: true,
};

export function getTemplateFeatures(tier: BackofficeTierTemplate): BackofficeOrganizationFeatures {
  return { ...DEFAULT_FEATURES, ...tier.features };
}
